import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../types/common.types';

import SystemNotice from './system-notice/SystemNotice';

import './system-notices.scss';

const SystemNotices = () => {
  const notices = useSelector((state: RootState) => state.system.notices);

  return (
    <div className="system-notices">
      {notices.map((notice) => {
        return <SystemNotice key={notice.id} notice={notice} />;
      })}
    </div>
  );
};

export default SystemNotices;
